export default __webpack_public_path__ + "resources/icons/n412-90b7.png";